module.exports = __webpack_public_path__ + "img/pad-work-1.41e03823.jpg";